import { CHANGE_AUX_STORE_ACTION } from './actions';

export const auxStoreReducer = (state, action) => {
  switch (action.type) {
    case CHANGE_AUX_STORE_ACTION:
      return { ...action.newObject };

    default:
      return state;
  }
};
